<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center"  v-if="checkPermission('AddContrat')">
        <router-link class="btn btn-primary" to="/contrats/ajouter-contrat">
          <i class="fa fa-plus-circle"></i>
          Ajouter un contrat
        </router-link>
      </div>
      <div class="col-md-4" v-if="point_ventes.length > 1">
    <div class="form-group mb-15 mb-sm-20 mb-md-25">
      <label class="d-block text-black fw-semibold mb-10">
       Filtrer par Point de vente
      </label>
      <div class="d-flex align-items-center" style="width: 200px;">
        <Multiselect 
          v-model="point_vente" 
          :options="point_ventes"  
          :searchable="true" 
          track-by="label" 
          label="label" 
          placeholder="Sélectionner un point de vente" 
        />
      </div>
    </div>
  </div>
      <div class="d-flex align-items-center">
        <form class="search-bg svg-color pt-3" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black"
            placeholder="Rechercher un contrat"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date de contrat
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Client
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Durée de créance
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Plafond
              </th>
              
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              >
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(contrat, index) in contrats" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_Date(contrat.dateContrat) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{
                  contrat?.client.nomClient && contrat?.client.prenomClient
                    ? `${contrat?.client.nomClient} ${contrat?.client.prenomClient}`
                    : contrat?.client.raisonSociale
                }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ contrat.dureeCreance }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ separateur(contrat.plafond) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                <div class="dropdown">
                  <button
                    class="btn dropdown-toggle btn-primary"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <!--<li>
                      <router-link
                        :to="{ name: 'EditContrat', params: { id: contrat.id } }"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>Modifier
                      </router-link>
                    </li>-->
                    <li>

                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="suppression(contrat.id, contrats, 'contrats', `le contrat ${contrat.id}`)"
                      >
                        <i class="fa fa-trash-o lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import Swal from "sweetalert2";
import { Contrat } from "@/models/Contrat";
import ApiService from "@/services/ApiService";
import { suppression, error, separateur,format_Date } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Multiselect from "@vueform/multiselect";

export default defineComponent({
  name: "ListeContrat",
  components: {
    PaginationComponent,
    Multiselect,
  },
  setup() {
    onMounted(async () => {
      if (JwtService.getPointDeVente()) {
        point_vente.value = await JwtService.getPointDeVenteId();
      }
      const pointVentes = await JwtService.getPointDeVentes();
      point_ventes.value = pointVentes ? pointVentes.map((point: any) => ({
        value: point.id,
        label: point.nomPointVente
      })) : [];
      getAllContrats(point_vente.value);
    });

    const contrats = ref<Array<Contrat>>([]);
    const contrat = ref<Contrat>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    let point_vente = ref<string>("");
    let point_ventes = ref([]);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllContrats(page_, limit_);
      } catch (error) {
        //
      }
    };
    
    watch(point_vente, () => {
      rechercher();
    });

    function rechercher() {
      getAllContrats(point_vente.value,page.value, limit.value, searchTerm.value);
    }

    // END PAGINATE

    function getAllContrats(point_vent,page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/contrats?page=${page}&limit=${limi}&mot=${searchTerm}&pointvente=${point_vent}&`)
        .then(({ data }) => {
          contrats.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    function moddifier(Editcontrats: Contrat) {
      contrat.value = Editcontrats;
    }

    const deleteContrat = (id: number) => {
      ApiService.delete(`/contrats/${id}`)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: 'success',
            title: 'General Title',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false,
          });
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Réessayer à nouveau!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });

      for (let i = 0; i < contrats.value.length; i++) {
        if (contrats.value[i].id === id) {
          contrats.value.splice(i, 1);
        }
      }
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    };

    return {
      contrats,
      checkPermission,
      getAllContrats,
      deleteContrat,
      moddifier,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      separateur,
      searchTerm,
      point_ventes,
      format_Date,
      point_vente
    };
  },
});
</script>